import { render, staticRenderFns } from "./mo-clickable-image.html?vue&type=template&id=1e9fa1b5&scoped=true&external"
import script from "./mo-clickable-image.ts?vue&type=script&lang=ts&external"
export * from "./mo-clickable-image.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-clickable-image.vue?vue&type=style&index=0&id=1e9fa1b5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9fa1b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/3/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e9fa1b5')) {
      api.createRecord('1e9fa1b5', component.options)
    } else {
      api.reload('1e9fa1b5', component.options)
    }
    module.hot.accept("./mo-clickable-image.html?vue&type=template&id=1e9fa1b5&scoped=true&external", function () {
      api.rerender('1e9fa1b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-clickable-image/mo-clickable-image.vue"
export default component.exports